<template>
    <reveal-view class="text-center">
        <h2 slot="header" class="title">Jaunumi</h2>
        <p>Vai piekrītat saņemt FIZMIX portāla jaunumus e-pastā?</p>
        <div class="text-center">
            <button class="large success button" type="button" @click="subscribe()" :disabled="processing" style="margin-right: 1em;">Piekrītu</button>
            <button class="large primary button" type="button" @click="unsubscribe()" :disabled="processing">Nepiekrītu</button>
        </div>

    </reveal-view>
</template>

<script>
    import { mapGetters } from 'vuex'
    import RevealView from '../common/RevealView';

    export default {
        name: "NewsletterReveal",

        components: {RevealView},

        data() {
            return {
                processing: false
            }
        },

        computed: {
            ...mapGetters(['user']),
        },

        methods: {
            subscribe() {
                const u = { ...this.user };
                u.newsletter = true;
                this.update(u);
            },
            unsubscribe() {
                const u = { ...this.user };
                u.newsletter = false;
                this.update(u);
            },
            update(user) {
                this.processing = true;
                return this.$store.dispatch('updateUser', user )
                    .then(response => {
                        this.$modal.closeReveal();
                        this.processing = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/NewsletterReveal.vue